export default __webpack_public_path__ + "static/media/BM_RenderCamera_17_DiningC+Interior+Light_Scheme+Living.c2dbdbe6.jpg";